import { createPendoServiceLoader } from '@reckon-web/pendo';

import { Config } from '../Config';

/**
 * Platform Pendo loader. Calling `LoadPendoService()` injects the Pendo agent
 * script; `LoadPendoService.onReady((pendo) => ...)` runs once the agent is
 * ready (e.g. to identify the visitor).
 */
export const LoadPendoService = createPendoServiceLoader({
  apiKey: Config.APPLICATION_PLATFORM_PENDO_API_KEY,
});
